import { createIcon } from '@chakra-ui/react'

export const BorderTopRightRadiusNegativeIcon = createIcon({
  displayName: 'BorderTopRightRadiusNegativeIcon',
  viewBox: '0 0 15.875 15.875',
  path: (
    <path fill='currentColor' d='M15.875 0H0A15.875 15.875 0 0 1 15.875 15.875V0z' />
  ),
})
